<template>
	<div class="added-to-cart">
		<div class="product-image">
			<img :src="pcGallery[0]" class="img-responsive">
		</div>
		<div class="product-details">
			<div class="product-title">
				<h1>Added to Cart</h1>
				<i class="fa fa-check" />
			</div>
			<div class="product-name-and-price">
				<p>{{ build.name }}</p>
				<promo-sales-timed>
					<template v-slot:originalContent>
						<span>- {{ build.price | formatMoney(0) }}</span>
					</template>
					<template>
						<span class="holiday-discount">
							- {{ promoDiscount(build.price) | formatMoney }}
							<span class="discounted-price">{{ build.price | formatMoney }}</span>
						</span>
					</template>
				</promo-sales-timed>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import PromoSalesTimed from "@/components/promo-sales-timed";
import { promoDiscount } from "@u/helpers";

export default {
	name: "AddedToCart",
	components: {
		PromoSalesTimed
	},
	computed: {
		...mapState({
			build: state => state.StarterPc.builds[state.StarterPc.buildsIndex]
		}),
		...mapGetters({
			pcGallery: "StarterPc/pcGallery"
		})
	},
	methods: {
		promoDiscount
	}
};
</script>

<style lang="scss" scoped>
.added-to-cart::v-deep {
	.discounted-price {
		text-decoration: line-through;
		font-size: 12px !important;
		margin: 0 !important;

		@media (min-width: 768px) {
			font-size: 14px !important;
		}
	}
}

.added-to-cart {
    display: flex;

    .product-image {
        width: 100px;

        @media (max-width: 991px) {
            width: 50px;
        }
    }

    .product-details {
        display: flex;
        flex-direction: column;
        margin-left: 20px;

        @media (max-width: 991px) {
            margin-left: 10px;
        }

        .product-title {
            display: flex;
            align-items: center;

            h1 {
                margin-top: 10px;
                color: #000000;
                font-size: 36px;
                line-height: 43px;
                margin-bottom: 2px;

                @media (max-width: 991px) {
                    font-size: 24px;
                    line-height: 29px;
                    margin-top: 0;
                    margin-bottom: 0;
                }
            }

            i {
                font-size: 40px;
                color: #21d373;
                margin-left: 10px;
                margin-bottom: 3px;

                @media (max-width: 991px) {
                    font-size: 26px;
                }
            }
        }

        .product-name-and-price {
            display: flex;
            align-items: center;

            p {
                margin-bottom: 0;
                color: #000000;
                font-size: 20px;
                line-height: 24px;

				@media (max-width: 767px) {
                    font-size: 14px;
                }

                @media (min-width: 768px) and (max-width: 991px) {
                    font-size: 16px;
                    line-height: 19px;
                }
            }

            span {
                color: #5f707f;
                font-size: 20px;
                line-height: 24px;
                margin-left: 5px;

				@media (max-width: 767px) {
                    font-size: 15px;
                }

                @media (min-width: 768px) and (max-width: 991px) {
                    font-size: 16px;
                    line-height: 19px;
                }
            }
        }
    }
}
</style>
